import {
  Avatars,
  FleetaLogoOnly,
  Modal,
  Typography,
} from '@thingsw/pitta-design-system';
import { LightColors, Webviewer } from '@thingsw/pitta-modules';
import React, { useEffect, useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';
import withSimpleBar from '../../hoc/withSimpleBar';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../features/store';
import { loadUserProfile, logout, USER } from '../../features/User/slice';
import { ProfileMenu } from '../../components/ProfileMenu';
import { useHistory } from 'react-router-dom';
import { loadSubscription } from '../../features/Payment/slice';
import { SurveyPanel } from '../../components/survey/SurveyPanel';
import { Theme, useMediaQuery, useTheme } from '@material-ui/core';

export const SurveyScreen = withSimpleBar(() => {
  const { t } = useTranslation();
  const history = useHistory();

  const [isOpenSkipModal, setIsOpenSkipModal] = useState(false);
  const [openProfileMenu, setOpenProfileMenu] = useState(false);
  const [isClickLogout, setIsClickLogout] = useState(false);

  const profileAnchorRef = useRef<HTMLDivElement>(null);
  const theme = useTheme() as Theme;
  const mobile = useMediaQuery(theme.breakpoints.down(Webviewer.mobile));

  const { userProfile } = useSelector((state: RootState) => state[USER]);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(loadUserProfile());
    dispatch(loadSubscription());
  }, [dispatch]);

  return (
    <div>
      <header
        style={{
          width: '100%',
          height: 56,
          borderBottom: `1px solid ${LightColors.primary['6']}`,
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '0px 24px',
        }}
      >
        <button
          onClick={() => {
            setIsOpenSkipModal(true);
          }}
        >
          <FleetaLogoOnly />
        </button>
        <Avatars
          style={{ cursor: 'pointer' }}
          ref={profileAnchorRef}
          name={userProfile?.email}
          imgSrc={userProfile?.profilePath}
          onClick={() => {
            setOpenProfileMenu(true);
          }}
        />
      </header>
      <SurveyPanel onSkip={() => setIsOpenSkipModal(true)} />
      <ProfileMenu
        open={openProfileMenu}
        anchorEl={profileAnchorRef.current}
        placement='bottom-end'
        isShowUpgrade={false}
        isDisableAccount={true}
        isDisableSettings={true}
        onClickAway={() => setOpenProfileMenu(false)}
        onCloseMenu={() => setOpenProfileMenu(false)}
        logoutCallback={() => {
          setIsClickLogout(true);
          setIsOpenSkipModal(true);
        }}
      />

      <Modal
        open={isOpenSkipModal}
        LButton={t('Cancel')}
        RButton={t('Skip')}
        fullWidthBtn={mobile}
        content={
          <Typography variant='H5'>{t('Would you like to skip?')}</Typography>
        }
        onClickAway={() => {
          if (isClickLogout) {
            setIsClickLogout(false);
          }
          setIsOpenSkipModal(false);
        }}
        onClickNegative={() => {
          if (isClickLogout) {
            setIsClickLogout(false);
          }

          setIsOpenSkipModal(false);
        }}
        onClickPositive={() => {
          // 설문 진행 중 로그아웃 여부 확인
          if (isClickLogout) {
            // 설문 종료 후 로그아웃

            dispatch(logout());
          } else {
            // 설문 종료 후 웹뷰어 화면으로 이동
            setIsOpenSkipModal(false);
            history.push('/cameras', { fleetaPromo: true });
          }
        }}
      />
    </div>
  );
});
